module.exports = __webpack_public_path__ + "img/5ae89bb.png";